import { create } from 'zustand'
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware'
import type { CalendarState, SchedulerViewType } from '@/routes/calendar/CalendarPage.types'

const DEFAULT_CALENDAR_PROPS = {
  selectedUserIds: [] as string[],
  currentSchedulerView: 'workWeek' as SchedulerViewType,
  colorOverrides: {} as Record<string, string>,
  customMode: false,
}

const createCalendarStore = () =>
  create<CalendarState>()(
    devtools(
      persist(
        subscribeWithSelector((set) => ({
          ...DEFAULT_CALENDAR_PROPS,
          setSelectedUserIds: (selectedUserIds: string[]) => set({ selectedUserIds }),
          setCurrentSchedulerView: (schedulerView: SchedulerViewType) => set({ currentSchedulerView: schedulerView }),
          saveColorOverride: (email: string, color: string | null) =>
            set((state) => {
              const next = { ...state.colorOverrides }
              if (color === null) delete next[email]
              else next[email] = color
              return { colorOverrides: next }
            }),
          toggleCustomMode: () => set((state) => ({ customMode: !state.customMode })),
        })),
        {
          name: 'calendar-store',
          version: 1,
          migrate: (persistedState: any, version: number) => {
            if (version === 0) {
              // Migra dai vecchi localStorage separati alla prima esecuzione
              return {
                ...persistedState,
                colorOverrides: JSON.parse(localStorage.getItem('calendar-user-colors') ?? '{}'),
                customMode: localStorage.getItem('calendar-custom-mode') === 'true',
              }
            }
            return persistedState
          },
        },
      ),
    ),
  )

export const useCalendarStore = createCalendarStore()
